import React from 'react';
import styled from 'styled-components';
import { Icon as AntIcon } from 'antd';
import { number, string, func } from 'prop-types';
import { Icon } from '../../common';

const BadgeContainer = styled.div`
    background-color: ${({ backgroundColor }) => backgroundColor};
    min-width: 14px;
    border-radius: 4px;
    max-height: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: ${({ badgeY = 6 }) => badgeY}px;
    left: ${({ badgeX = 7 }) => badgeX}px;
`;

const BadgeText = styled.div`
    font-size: 9px;
    font-weight: bold;
    color: #ffffff !important;
    :hover {
        color: #ffffff !important;
    }
`;

const IconBadgeWrapper = styled.div`
    position: relative;
`;

const IconBadge = ({ count, name, size, badgeX, badgeY, onClick, color, backgroundColor }) => (
    <IconBadgeWrapper onClick={onClick}>
        { count > 0 && (
            <BadgeContainer badgeX={badgeX} badgeY={badgeY} backgroundColor={backgroundColor}>
                <BadgeText>{ count }</BadgeText>
            </BadgeContainer>
        ) }
        <AntIcon component={() => <Icon name={name} color={color} size={size} />} />
    </IconBadgeWrapper>
);

IconBadge.propTypes = {
    count: number,
    name: string,
    size: number,
    badgeX: number,
    badgeY: number,
    onClick: func,
    color: string,
    backgroundColor: string
};

IconBadge.defaultProps = {
    size: 16,
    onClick: () => {},
    color: '#ffffff',
    backgroundColor: '#a4c735'
};
export default IconBadge;
